import { FieldOption } from 'module/api/field/types';
import { Tag } from '@rocketlane/ui';
import { SignalOption, SignalType } from 'api/custom-section/types';
import { CustomSectionState } from 'api/custom-section/types';
import { useState } from 'react';
import styled from 'styled-components';
import { FlexWrapperWithShortGap } from 'components/common/styles';
import { SectionHeading } from 'components/organisms/document-editor/extensions/custom-section/ui/shared/section-heading';
import { SignalPromptInput } from './prompt-input';
import {
  SectionCard,
  SectionPreview,
  SectionTitle,
} from '../../../shared/section-styles';
import { SignalDetailsSectionComponentProps } from '../types';

const TagsWrapper = styled(FlexWrapperWithShortGap)`
  margin-top: var(--spacing-05);
  flex-wrap: wrap;
`;

export const SignalPromptSection = ({
  node,
  onDone,
  onUndo,
  onRemove,
  onOpen,
}: SignalDetailsSectionComponentProps) => {
  const showPrompt = node.attrs.state === CustomSectionState.Open;
  const [prompt, setPrompt] = useState({
    signalType:
      (node?.attrs?.config?.signalOption as SignalType) || SignalOption.ALL,
    signalsSelected: node?.attrs?.signalsSelected || [],
  });
  const [isGenerating, setIsGenerating] = useState(false);

  const onGenerate = async (userPrompt: {
    signalType: SignalType;
    signalsSelected: FieldOption<number>[];
  }) => {
    setIsGenerating(true);

    const attributes = {
      ...node.attrs,
      title: 'Signals',
      signalOption: userPrompt.signalType,
      signalsSelected: userPrompt?.signalsSelected ?? [],
      componentType: 'SignalGeneratedSection',
      state: CustomSectionState.Closed,
      config: {
        title: 'Signals',
        sectionType: 'SIGNAL_DETAILS',
        identifier: 'SIGNAL',
        signalOption: userPrompt?.signalType?.toUpperCase() as SignalType,
        signalConfigurationIds: userPrompt?.signalsSelected?.map(
          (signal: any) => signal?.value,
        ),
      },
    };

    onDone(attributes).then(() => {
      setIsGenerating(false);
    });
  };

  return (
    <>
      {showPrompt ? (
        <SectionCard>
          <SectionHeading title="Signals" onClose={onUndo} />
          <SignalPromptInput
            prompt={prompt}
            setPrompt={setPrompt}
            onGenerate={onGenerate}
            isGenerating={isGenerating}
            onCancel={onRemove}
            showCancelButton={true}
          />
        </SectionCard>
      ) : (
        <SectionPreview onClick={() => onOpen()}>
          <SectionTitle>{node.attrs?.title || 'Signals'}</SectionTitle>
          <TagsWrapper>
            {(node.attrs.config?.signalOption as SignalOption) ===
              SignalOption.ALL &&
              node.attrs.config?.signalConfigurationIds?.length === 0 && (
                <Tag color="blue" variant="basic">
                  All Signals
                </Tag>
              )}
            {node.attrs &&
              (node.attrs.config?.signalOption as SignalOption) ===
                SignalOption.SPECIFIC &&
              node.attrs.config?.signalConfigurationIds &&
              node.attrs.config?.signalConfigurationIds?.length > 0 &&
              node.attrs.signalsSelected?.map((signal: any) => (
                <Tag color={signal?.color} key={signal?.value} variant="basic">
                  {signal.label}
                </Tag>
              ))}
          </TagsWrapper>
        </SectionPreview>
      )}
    </>
  );
};
